import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Avatar,
  Menu,
  Dropdown,
  Badge,
} from 'antd';
import { Link } from 'react-router-dom';

import styles from './UserBar.module.css';

class UserBar extends PureComponent {
  state = {
    user: {}
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      this.props.fetchNewTickets(() => {
       this.setState({
         user: {
           ...this.props.user,
           timeZone: this.props.user.time_zone
         }
       });
      });
    });
  };

  render() {
    const {
      user: {
        login,
        balance,
        count,
        timeZone
      }
    } = this.state;

    let dropdown = null;
    if (login) {
      let infoMenu = (
        <Menu>
          <Menu.Item key="login">
            <Link to="/profile">Login: {login}</Link>
          </Menu.Item>
          <Menu.Item key="balance" className={styles.item}>
            Balance: ${balance}
          </Menu.Item>
          <Menu.Item key="timezone" className={styles.item}>
            <span>Time Zone: {timeZone}</span>
          </Menu.Item>
        </Menu>
      );

     dropdown = (
       <Dropdown
         overlay={infoMenu}
         trigger={['click']}
       >
        <span className={styles.info}>
          <Icon type="down"/>
        </span>
       </Dropdown>
     )
    }

    return (
      <div className={styles.bar}>
        <Link
          to="/tickets/opened"
          title="Show Opened Ticket"
          className={styles.link}
        >
          <Badge
            className={styles.notify}
            count={count}
          >
            <Avatar
              className={styles.avatar}
              icon="user"
            />
          </Badge>
        </Link>
        {dropdown}
      </div>
    );
  }
}

UserBar.propTypes = {
  user: PropTypes.object.isRequired,
  fetchNewTickets: PropTypes.func.isRequired,
};

export default UserBar;
